module.exports = __webpack_public_path__ + "static/media/Stock-Footage-of-Shopping-for-Womens-Clothing.cfbb809d.mp4";